module.exports = __webpack_public_path__ + "media/images/contact-us/call-icon-0ccef069a21f5defa72e8806dce72eb5.svg";